<template>
  <div
    class="other-service"
    :class="{ 'other-service-pb': !isHaveMoreLook }"
    v-if="products.length > 0"
  >
    <div class="serve_introduce_title pf-medium">本店其他推荐</div>
    <div class="service-item-wrap">
      <div
        class="service-item"
        @click="goDetail(item)"
        v-for="(item, index) in products"
        v-show="showNum > index"
        :key="item && item.spuId"
      >
        <div class="item-img">
          <div class="tag" v-if="!!imgTally(item)">
            <p class="tag-main">
              <i>{{ imgTally(item) }}</i>
            </p>
          </div>
          <img
            class="avatar"
            v-lazy="$$viewImageInCenter(item.cmmdtyImage)"
            alt=""
          />
        </div>
        <div class="item-desc">
          <div class="desc">
            <div class="title">
              <span>
                {{ item && item.spuName }}
              </span>
            </div>
          </div>
          <div class="label-price">
            <div class="price-wrap">
              <span class="pf-medium">&yen;</span>
              <span class="price pf-medium">{{ getPrice(item) | price1 }}</span>
              <i>{{ item | priceRange }}</i>
            </div>
            <b
              v-for="(p, index) in seekCommodityPromotion(item, 2)"
              :key="index"
              >{{ p }}</b
            >
          </div>
        </div>
        <div class="item-rs">
          <div class="count">
            <span>已售</span>
            <span>{{ item.saleNum | integer }}</span>
          </div>
        </div>
      </div>
    </div>
    <button
      ref="moreLook"
      class="more-look"
      :class="{ isShowAll }"
      v-if="isHaveMoreLook"
      @click="openMore"
    ></button>
  </div>
</template>

<script>
export default {
  inject: {
    otherProductTrackParams: {
      default: null
    }
  },
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPdIndex: 1,
      MIN_SHOW: 6,
      isShowAll: false
    }
  },
  computed: {
    showNum() {
      return this.isShowAll ? Infinity : this.MIN_SHOW
    },
    isHaveMoreLook() {
      return this.products.length > this.MIN_SHOW
    }
  },
  methods: {
    goDetail(item) {
      this.otherProductTrackParams &&
        this.$$newTrackClick(this.otherProductTrackParams)
      location.href = `/v/product/${item.spuId}?refresh=no`
    },
    openMore() {
      this.isShowAll = !this.isShowAll
      this.$nextTick(() => {
        this.$refs.moreLook.scrollIntoView({
          behavior: 'smooth'
        })
      })
    },
    getPrice(item) {
      return item.minPrice
    },
    imgTally(item) {
      return this.seekCommodityPromotion(item, 1)
    },
    //标签 1营销标签 promotion1 接口约定只有一个  2普通标签 promotion2 最多4个
    seekCommodityPromotion(item, type) {
      const { promotion1 = [], promotion2 = [] } = JSON.parse(item.promotions)
      if (type === 1) {
        const [p = ''] = promotion1
        return p
      } else {
        return promotion2
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.other-service {
  margin-top: rem(20px);
  padding: rem(32px) rem(30px) 0;
  background: white;

  .serve_introduce_title {
    font-size: rem(32px);
    color: #121212;
  }

  .service-item-wrap {
    display: flex;
    margin-top: rem(8px);
    flex-wrap: wrap;
    justify-content: space-between;
    .service-item {
      margin-top: rem(16px);
      width: rem(336px);
      background: #ffffff;
      border: 1px solid #ededed;
      border-radius: rem(16px);
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      overflow: hidden;
      .item-img {
        position: relative;
        width: rem(336px);
        height: rem(193px);
        .tag {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: rem(28px);
          z-index: 1;
          .tag-main {
            @include tripleCenter;
            justify-content: flex-start;
            i {
              font-size: rem(66px);
              line-height: rem(84px);
              color: #ffffff;
              background-image: linear-gradient(
                90deg,
                #ff8700 0%,
                #ff5900 100%
              );
              border-bottom-right-radius: rem(24px);
              padding: 0 rem(30px);
            }
          }
        }
        .avatar {
          width: rem(336px);
          height: rem(193px);
          object-fit: cover;
        }
      }
      .item-desc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: rem(12px) rem(20px) rem(16px);
        overflow: hidden;
        .desc {
          margin-bottom: rem(12px);
          .title {
            text-overflow: ellipsis;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            font-size: rem(24px);
            color: #121212;
            letter-spacing: 0;
            line-height: rem(30px);
            height: rem(30px);
          }
        }
        .label-price {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          height: rem(30px);
          overflow: hidden;
          .price-wrap {
            color: #ff5900;
            display: flex;
            align-items: flex-end;
            overflow: hidden;
            margin-right: rem(6px);
            span {
              white-space: nowrap;
              font-size: rem(32px);
              line-height: rem(30px);
            }
            span.price {
              @include ellicpsis;
            }
            i {
              font-size: rem(24px);
              line-height: rem(24px);
              letter-spacing: 0;
            }
          }
          b {
            display: block;
            @include border(all, rgba(255, 89, 0, 0.5), 1px, 2px);
            // border-radius: 4px;
            // border: 1px solid rgba(255, 89, 0, 0.5);
            font-size: rem(20px);
            color: #ff5900;
            height: rem(28px);
            line-height: normal;
            display: flex;
            align-items: center;
            margin-right: rem(10px);
            font-weight: normal;
            padding: 0 rem(8px);
          }
        }
      }
      .item-rs {
        padding: 0 rem(20px) rem(16px);
        .count {
          text-align: center;
          font-size: rem(22px);
          color: #666666;
          letter-spacing: 0;
          line-height: rem(28px);
          display: flex;
          overflow: hidden;
          flex-wrap: nowrap;
          span {
            white-space: nowrap;
          }
          span:first-child {
            margin-right: rem(6px);
          }
          span:last-child {
            @include ellicpsis;
          }
        }
      }
    }
  }

  .more-look {
    display: block;
    width: 100%;
    height: rem(92px);
    background: url('~@/assets/images/product/btn-ckgd@3x.png') no-repeat;
    background-position: center;
    background-size: rem(134px) auto;
  }

  .isShowAll {
    background-image: url('~@/assets/images/product/btn-sq@3x.png');
    background-size: rem(82px) auto;
  }
}

.other-service-pb {
  padding: rem(32px) rem(30px);
}
</style>
